import React from "react";
import Linkify from "react-linkify";
import { targetBlankDecorator } from "../../../utils/LinkifyDecorator";
import DOMPurify from "dompurify";

export default ({ description }) => {
  return (
    <Linkify componentDecorator={targetBlankDecorator}>
      <div
        className="card__content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        style={{ marginTop: 14 }}
      ></div>
    </Linkify>
  );
};
